export default function guest({ next, store }) {
  if (!store.getters['auth/isAuthenticated']) {
    next()
    return
  }
  next('/dashboard')
}
